var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultipleDocuments({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.18422 0V1.99031H4.19391V3.98438H2.20312V24H17.8158V22.0083H19.8075V20.018H21.7969V0H6.18422ZM16.8548 23.0391H3.16266V4.94531H4.19391V22.0083H16.8548V23.0391ZM18.8466 21.0469H5.15625V2.95312H6.1875V20.018H18.8466V21.0469ZM20.8373 19.0566H7.14516V0.960938H20.8373V19.0566Z",
    fill: "current",
    stroke: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9554 3.04175H8.90723V3.80347H18.9554V3.04175Z",
    fill: "current",
    stroke: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9554 7.48596H8.90723V8.24768H18.9554V7.48596Z",
    fill: "current",
    stroke: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9554 5.2439H8.90723V6.00561H18.9554V5.2439Z",
    fill: "current",
    stroke: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9554 9.68811H8.90723V10.4498H18.9554V9.68811Z",
    fill: "current",
    stroke: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9554 11.9297H8.90723V12.6914H18.9554V11.9297Z",
    fill: "current",
    stroke: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9554 14.1319H8.90723V14.8936H18.9554V14.1319Z",
    fill: "current",
    stroke: "current"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9913 16.3744H8.90674V17.1352H13.9913V16.3744Z",
    fill: "current",
    stroke: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleDocuments);
export default __webpack_public_path__ + "static/media/multiple-documents.a034e1b41680c0d09c81376a65485c1f.svg";
export { ForwardRef as ReactComponent };